var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArchedTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M48 19.97h0c-6.22 0-11.26 5.04-11.26 11.26V58.3c0 .96.77 1.73 1.73 1.73h19.06c.96 0 1.73-.77 1.73-1.73V31.23c0-6.22-5.04-11.26-11.26-11.26Zm0 5.56a1.73 1.73 0 1 1 .001-3.461A1.73 1.73 0 0 1 48 25.53Z"
  })));
};
export default SvgArchedTag;